import { asRecord, stringValue } from "./ToolResultView.utils";

export const commandActions: Record<string, string> = {
  agent_workspace_command_await: "Wait for command",
  agent_workspace_command_inspect: "Inspect command",
  agent_workspace_command_stdin: "Send command input",
  agent_workspace_command_stop: "Stop command",
};

export function isAsyncCommand(name: string, result?: unknown) {
  return (
    Object.hasOwn(commandActions, name) ||
    (name === "agent_workspace_shell" &&
      Boolean(stringValue(asRecord(result)?.commandId)))
  );
}

export function asyncCommandState(
  result: unknown,
  status?: string,
  error?: string,
) {
  const output = asRecord(result) ?? {};
  if (error || stringValue(output.error) || status === "failed")
    return "failed";
  const processStatus = stringValue(output.status);
  if (
    ["queued", "running", "completed", "failed", "stopped"].includes(
      processStatus,
    )
  )
    return processStatus;
  return status || "running";
}
